<ui-object-navigation-main-page alias="co"></ui-object-navigation-main-page>